import {
	observer
} from 'mobx-react';
import {
	WeaDialog,
} from 'ecCom';
import {
	Loading,
} from '../../public/learn';
// import Browser from './Browser';
import DialogForm from './DialogForm';

@observer
export default class Dialog extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			store
		} = this.props, {
			DIALOG,
			dialog,
			tab,
			dialogStyle,
		} = store, {
			selectedKey
		} = tab;

		let c;
		if (dialog.loading) {
			c = <Loading />;
		} else {
			if (selectedKey === '1') {
				// c = <Browser store={store}/>;
			} else {
				c = <DialogForm store={store}/>;
			}
		}


		return (
			<WeaDialog
				{...DIALOG}
				{...dialog}
				style={dialogStyle}
			>
				{c}
			</WeaDialog>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/group/Dialog.js